export const TOGGLE_NIVEAU_FILTER_MENU = 'ibw/SearchNiveau/TOGGLE_NIVEAU_FILTER_MENU';
